class Statistics {
    constructor() {
        this.initCounters();
    }

    initCounters() {
        if (!document.querySelectorAll('.statistics')) {
            return;
        }

        ScrollTrigger.batch('.statistics', {
            // markers: true,
            onEnter: (elements) => {
                if (this.numbersCounted) {
                    return;
                }
                this.numbersCounted = true;

                elements.forEach((element) => {
                    const items = document.querySelectorAll('.statistics .stat .value');
                    gsap.from(items, {
                        textContent: 0,
                        duration: 3,
                        ease: 'Power1.easeInOut',
                        snap: { textContent: 1 },
                        stagger: {
                            each: 0,
                            onUpdate: function () {
                                this.targets()[0].innerHTML = Math.ceil(this.targets()[0].textContent);
                            }
                        },

                        onComplete: () => {
                            element.classList.add('completed');
                        }
                    });
                });
            },
            start: 'top 80%',
            end: 'bottom top'
        });
    }
}
new Statistics();
